import { FC, InputHTMLAttributes } from 'react'

import { useField } from 'formik'

import { BaseProps } from '../Field'
import {
  Asterisk,
  Caption,
  LabelText,
  StyledInputContainer,
  StyledNumberInput,
} from './styles'

export interface PropsType
  extends BaseProps, Omit<InputHTMLAttributes<HTMLInputElement>, 'name'> {
  allowEmptyValue?: boolean
  className?: string
  success?: boolean
  disabled?: boolean
  clearDefaultValueOnFocus?: boolean
  isCurrency?: boolean
  scale?: number
  precision?: number
  percent?: boolean
  adjustmentType?: 'ADDITIVE' | 'SUBTRACTIVE' | 'MARKUP'
  onlyNaturalNumbersAllowed?: boolean
  allowComma?: boolean
  maxAmount?: number
}

const NumberInput: FC<PropsType> = ({ required, ...props }) => {
  const [
    { onChange: _fieldOnChange, onBlur: _fieldOnBlur, value, ...field },
    meta,
    { setValue, setTouched },
  ] = useField({
    disabled: props.disabled,
    name: props.name,
  })
  const shouldShowError = meta.touched && !!meta.error
  return (
    <label htmlFor={props.name}>
      <LabelText disabled={props.disabled} hasError={!!shouldShowError}>
        {props.label} {required ? <Asterisk>*</Asterisk> : null}
      </LabelText>
      <StyledInputContainer
        disabled={props.disabled}
        hasError={shouldShowError}
      >
        <StyledNumberInput
          onBlur={(_: any, { value }: HTMLInputElement) => {
            setTouched(true)
            setValue(value)
          }}
          isRequired={required}
          defaultValue={value}
          {...(shouldShowError && { errorMessage: meta.error })}
          {...field}
          {...props}
        />
      </StyledInputContainer>
      {(props.caption || !!shouldShowError) && (
        <Caption disabled={props.disabled} hasError={!!shouldShowError}>
          {meta.error || props.caption}
        </Caption>
      )}
    </label>
  )
}

export default NumberInput
